import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Operator from "./components/Operator/Operator.jsx";
import Patient from "./components/Patient/Patient.jsx";
import Admin from "./components/Admin/Admin.jsx";
import OperatorList from "./components/Admin/OperatorList.jsx";
import AdminAddOperator from "./components/Admin/AdminAddOperator.jsx";
import PatientResetPassword from "./components/Patient/PatientResetPassword.jsx";
import PatientChangePassword from "./components/Patient/PatientChangePassword.jsx";
import OperatorResetPassword from "./components/Operator/OperatorResetPassword.jsx";
import OperatorChangePassword from "./components/Operator/OperatorChangePassword.jsx";
// import OperatorAddPatient from "./components/Operator/OperatorAddPatient.jsx";
// import Physicians from "./components/Landing/NewLanding Page/Physician";
import Patients from "./components/Landing/NewLanding Page/PatientLandingNew.jsx";
import Physicians from "./components/Landing/NewLanding Page/PhysicianLandingNew.jsx";
// import LandingPageHome from "./components/Landing/NewLanding Page/LandingPageHome.jsx";
import LandingPageHomeNew from "./components/Landing/NewLanding Page/LandingPageHomeNew.jsx";
// import Patients from "./components/Landing/NewLanding Page/Patients";
import AdminPage from "./components/Landing/NewLanding Page/Admin.jsx";
import AdminScanRequestList from "./components/Admin/AdminScanRequestList.jsx";
import AboutUs from "./components/Landing/NewLanding Page/AboutUs.jsx";
import PatientLogin from "./components/Patient/PatientLogin.jsx";
import PatientRegistration from "./components/Patient/PatientRegistration.jsx";
import OperatorPatientListNew from "./components/Operator/OperatorPatientListNew.jsx";
import NavbarNew from "./components/Navbar/NavbarNew.jsx";
import OperatorScanListNew from "./components/Operator/OperatorScanListNew.jsx";
import OperatorPatientList from "./components/Operator/OperatorPatientList.jsx";
import Example from "./components/Operator/example.jsx";
import Notification from "./components/Operator/Notification.jsx";

import PatientProfile from "./components/Operator/PatientProfileNew.jsx";
import OperatorProfile from "./components/Operator/OperatorProfile.jsx";
import AdminProfile from "./components/Admin/AdminProfile.jsx";
import OperatorPatientFilesNew from "./components/Operator/OperatorPatientFilesNew.jsx";
// import OperatorPatientFiles from "./components/Operator/OperatorPatientFiles.jsx";
import OperatorPatientRegister from "./components/Operator/OperatorPatientRegister.jsx";
import FeedbackOperator from "./components/Operator/FeedbackOperator.jsx";
import ContactUs from "./components/Landing/NewLanding Page/ContactUs.jsx";
import AdminOperatorRegister from "./components/Admin/AdminOperatorRegister.jsx";
import PatientAuthorizationForm from "./components/Patient/PatientAuthorizationForm.jsx";
import TermsAndConditions from "./components/Landing/NewLanding Page/TermsAndConditions.jsx";
import PrivacyPolicy from "./components/Landing/NewLanding Page/PrivacyPolicy.jsx";
import ContactUsLanding from "./components/Landing/NewLanding Page/ContactUsLanding.jsx";
import AboutUsPage from "./components/Operator/AboutUs.jsx";
import ForbiddenPage from "./components/Landing/Forbidden.jsx";
// import OperatorPatientRegister from "./components/Operator/OperatorPatientRegister";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<LandingPageHomeNew />} />
        <Route exact path="/example" element={<Example />} />
        <Route path="/physicians" element={<Physicians />} />
        <Route path="/patients" element={<Patients />} />
        <Route path="/adminPage" element={<AdminPage />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/operator" element={<OperatorPatientList />} />
        <Route path="/aboutuspage" element={<AboutUsPage />} />
        {/* <Route path="/operator/:next" element={<Operator />} /> */}
        <Route path="/patient" element={<PatientLogin />} />
        <Route path="/patient-register" element={<PatientRegistration />} />
        <Route path="/patient/:next" element={<Patient />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/navbar" element={<NavbarNew />} />
        <Route exact path="/notifications" element={<Notification />} />
        {/* <Route path="/patientRegister" element={<OperatorPatientRegister />} /> */}
        <Route
          path="/operatorPatientlist"
          element={<OperatorPatientListNew />}
        />
        <Route path="/scan" element={<OperatorScanListNew />} />
        <Route path="/files" element={<OperatorPatientFilesNew />} />
        <Route path="/profile" element={<PatientProfile />} />
        <Route path="/operatorProfile" element={<OperatorProfile />} />
        <Route path="/adminProfile" element={<AdminProfile />} />
        <Route path="/feedback" element={<FeedbackOperator />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/ContactUsLanding" element={<ContactUsLanding />} />
        <Route path="/operatorList" element={<OperatorList />} />
        <Route path="/authForm" element={<PatientAuthorizationForm />} />
        <Route path="/adminScanRequests" element={<AdminScanRequestList />} />
        <Route
          path="/register-operator/:token"
          element={<AdminAddOperator />}
        />
        <Route
          path="/patient/reset-password"
          element={<PatientResetPassword />}
        />
        <Route
          path="/patient/change-password/:token"
          element={<PatientChangePassword />}
        />
        <Route
          path="/operator/reset-password"
          element={<OperatorResetPassword />}
        />
        <Route
          path="/operator/change-password/:token"
          element={<OperatorChangePassword />}
        />
        <Route path="/invite/:token" element={<OperatorPatientRegister />} />
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route
          path="/provider/invite/:token"
          element={<AdminOperatorRegister />}
        />
        <Route path="/403" element={<ForbiddenPage />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
